const myActivitiesActionTypes = {
  GET_MY_EXPS: "myActivitiesApp/GET_MY_EXPS",
  UPDATE_MY_EXPS: "myActivitiesApp/UPDATE_MY_EXPS",
  FETCH_SCORE_CARDS: "myActivitiesApp/FETCH_SCORE_CARDS",
  UPDATE_SCORE_CARDS: "myActivitiesApp/UPDATE_SCORE_CARDS",
  UPDATE_STATUS_DATA: "myActivitiesApp/UPDATE_STATUS_DATA",
  FETCH_STATUS: "myActivitiesApp/FETCH_STATUS",
  SET_USER_CONTEXT: "myActivitiesApp/SET_USER_CONTEXT",
  SET_PARTIAL_USER_CONTEXT: "myActivitiesApp/SET_PARTIAL_USER_CONTEXT"
};
export {
  myActivitiesActionTypes as default
};
//# sourceMappingURL=MyActivitiesActionTypes.js.map
